import { Injectable } from "@angular/core";
import { ApiService } from "../api.service";

const PATH = "account-app-user-region-compare-group";

@Injectable({
  providedIn: "root",
})
export class AccountAppUsersRegionCompareGroupHandlerService {
  constructor(private APIService: ApiService) {}

  postCompareGroup(compareGroupDTO: any) {
    return this.APIService.post(`${PATH}`, compareGroupDTO);
  }

  putCompareGroup(compareGroupDTO: any) {
    return this.APIService.put(
      `${PATH}/${compareGroupDTO.id}`,
      compareGroupDTO,
    );
  }

  postCompareGroupList(userID: number, accountAppID: number) {
    return this.APIService.post(`${PATH}/list`, {
      user_id: userID,
      account_app_id: accountAppID,
    });
  }

  deleteCompareGroup(compareGroupID: number) {
    return this.APIService.delete(`${PATH}/${compareGroupID}`);
  }
}
